export default "__VITE_ASSET__CNGyBv9M__"